// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, setServiceProperties, getServiceProperties } from "./operations.js";
export type {
  BlobServicesListOptionalParams,
  BlobServicesSetServicePropertiesOptionalParams,
  BlobServicesGetServicePropertiesOptionalParams,
} from "./options.js";
